import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDeviceListControlsCoCo } from './useDeviceListControlsCoCo.js';
import type { DeviceSelectionDeviceCoCo } from '../utils/deviceSelectionDeviceUtilsCoCo.js';

const NO_SELECTED_FIRST_IDS: ReadonlySet<string> = new Set();

export const useDeviceSelectionDeviceListCoCo = (devices: DeviceSelectionDeviceCoCo[], selectedIdsName: string) => {
  const { getValues } = useFormContext();
  const [selectedFirstIds, setSelectedFirstIds] = useState(NO_SELECTED_FIRST_IDS);
  const controls = useDeviceListControlsCoCo(devices, selectedFirstIds);

  const setSort = (newSort: typeof controls.sort) => {
    controls.setSort(newSort);
    setSelectedFirstIds(NO_SELECTED_FIRST_IDS);
  };

  // Snapshot the selection on click so that checking devices doesn't make rows jump.
  const showSelectedFirst = () => setSelectedFirstIds(new Set<string>(getValues(selectedIdsName) ?? []));

  return {
    ...controls,
    setSort,
    showSelectedFirst,
  };
};
